import * as table0 from './tables/0.json';
import * as table1 from './tables/1.json';
import * as table2 from './tables/2.json';
import * as table3 from './tables/3.json';
import * as table4 from './tables/4.json';
import * as table5 from './tables/5.json';
import * as table6 from './tables/6.json';
import * as table8 from './tables/8.json';

export const textTables = [
  {
    image: '/images/workspace/text-table/6.png',
    content: table6,
  },
  // {
  //   image: '/images/workspace/text-table/7.png',
  //   content: table7,
  // },
  {
    image: '/images/workspace/text-table/8.png',
    content: table8,
  },
  {
    image: '/images/workspace/text-table/0.png',
    content: table0,
  },
  {
    image: '/images/workspace/text-table/1.png',
    content: table1,
  },
  {
    image: '/images/workspace/text-table/2.png',
    content: table2,
  },
  {
    image: '/images/workspace/text-table/3.png',
    content: table3,
  },
  {
    image: '/images/workspace/text-table/4.png',
    content: table4,
  },
  {
    image: '/images/workspace/text-table/5.png',
    content: table5,
  },
];
